import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'Acasă',
    href: 'https://academiadeabundenta.ro/'
  }, {
    name: 'Cursuri Online',
    href: 'https://academiadeabundenta.ro/magazin'
  }, {
    name: 'Terapie 1 la 1',
    href: 'https://academiadeabundenta.ro/oferta1la1'
  }, {
    name: 'Despre Mine',
    href: 'https://academiadeabundenta.ro/despremine'
  }, {
    name: 'Mărturii',
    href: 'https://academiadeabundenta.ro/testimoniale'
  }, {
    name: 'Contact',
    href: 'https://academiadeabundenta.ro/contact'
  }];
  const sesiuneHref = 'https://academiadeabundenta.ro/sesiune-cadou';
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm py-4" data-id="element-1350">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between relative" data-id="element-1351">
        <a href="https://academiadeabundenta.ro" target="_top" className="flex items-center" aria-label="Academia de Abundență — Acasă" data-id="element-1352">
          <img src="https://cdn.magicpatterns.com/uploads/k7XgNUvbMN8qQ8DdgYxEKU/Screenshot_2026-05-15_at_06.30.28.png" alt="Academia de Abundență" className="h-12 lg:h-14 w-auto object-contain" data-id="element-1353" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-1354">
          <ul className="flex items-center gap-8" data-id="element-1355">
            {navLinks.map(link => <li key={link.name} data-id="element-1356">
                <a href={link.href} target="_top" className="font-heading font-semibold text-[15px] text-brand-purple hover:text-brand-gold transition-colors" data-id="element-1357">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href={sesiuneHref} target="_top" className="bg-brand-gold text-brand-cream font-heading font-semibold px-6 py-3 rounded-xl hover:bg-brand-purple transition-colors duration-300 shadow-warm hover:shadow-warm-hover" data-id="element-1358">
            Sesiune Cadou
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-brand-purple p-2 relative z-[110]" onClick={() => setIsMobileMenuOpen(v => !v)} aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMobileMenuOpen} data-id="element-1359">
          {isMobileMenuOpen ? <X size={28} data-id="element-1360" /> : <Menu size={28} data-id="element-1361" />}
        </button>
      </div>

      {/* Mobile Nav — solid purple dropdown directly below header */}
      <AnimatePresence data-id="element-1362">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.2
      }} style={{
        backgroundColor: '#4F2E7E'
      }} className="lg:hidden absolute top-full left-0 right-0 shadow-2xl border-t-2 border-brand-gold/40" data-id="element-1363">
            <nav className="px-6 py-6 flex flex-col" data-id="element-1364">
              <ul className="flex flex-col gap-1 mb-6" data-id="element-1365">
                {navLinks.map(link => <li key={link.name} data-id="element-1366">
                    <a href={link.href} target="_top" className="font-heading font-semibold text-lg text-white hover:text-brand-gold transition-colors block py-3 border-b border-white/15" onClick={() => setIsMobileMenuOpen(false)} data-id="element-1367">
                      {link.name}
                    </a>
                  </li>)}
              </ul>
              <a href={sesiuneHref} target="_top" className="bg-brand-gold text-brand-cream font-heading font-semibold px-6 py-4 rounded-xl text-center hover:bg-white hover:text-brand-purple transition-colors duration-300 shadow-warm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-1368">
                Sesiune Cadou
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}